export function HomiLogo({ size = 40, showTag = true }) {
  return (
    <div className="flex items-center gap-3">
      <div
        style={{ width: size, height: size }}
        className="rounded-full border flex items-center justify-center"
      >
        <span
          className="font-serif font-light"
          style={{ color: 'var(--sage)', fontSize: size * 0.5 }}
        >H</span>
      </div>
      {showTag && (
        <div>
          <div className="font-serif text-xl tracking-brand uppercase" style={{ color: 'var(--sage)' }}>HomiHQ</div>
          <div className="hq-eyebrow -mt-0.5">Powered by Hired</div>
        </div>
      )}
      <style>{`
        .rounded-full.border { border-color: var(--gold); border-width: 1.5px; }
      `}</style>
    </div>
  );
}
